import React, { createContext, useContext, useState, useEffect } from "react";
import { authAPI, clientAccessAPI } from "../services/api"; // ajay:code 11-08-26

const AuthContext = createContext(null);

const MOCK_USERS = {
  "superadmin@weightqa.com": {
    password: "SuperAdmin@123",
    user: {
      id: 1,
      name: "Super Admin",
      email: "superadmin@weightqa.com",
      user_type: "superadmin",
      avatar: "SA",
      permissions: [],
    },
  },
  "admin@acmeplastics.com": {
    password: "Company@123",
    user: {
      id: 2,
      name: "Company Admin",
      email: "admin@acmeplastics.com",
      user_type: "company",
      avatar: "CA",
      permissions: [],
    },
  },
  "client@acmeplastics.com": {
    password: "Client@123",
    user: {
      id: 3,
      name: "Client User",
      email: "client@acmeplastics.com",
      user_type: "client",
      avatar: "CU",
      permissions: [
        "view_dashboard",
        "view_weight_history",
        "view_live_data",
        "export_data",
      ],
    },
  },
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [companies, setCompanies] = useState([]); // client_user: list of linked companies  ajay:code 11-08-26
  const [activeCompany, setActiveCompany] = useState(null); // { company_id, company_name, protected_pages }  ajay:code 11-08-26

  // Restore session on page load
  useEffect(() => {
    const token = localStorage.getItem("wqa_token");
    if (!token) {
      setLoading(false);
      return;
    }

    // Mock token restore
    if (token.startsWith("mock_token_")) {
      const email = token.replace("mock_token_", "");
      const mock = MOCK_USERS[email];
      if (mock) setUser(mock.user);
      setLoading(false);
      return;
    }

    const timeout = setTimeout(() => {
      localStorage.removeItem("wqa_token");
      setLoading(false);
    }, 3000);

    authAPI
      .me()
      // .then((res) => {
      //   setUser(res.data);
      // })
      //ajay:code 11-08-26
      .then(async (res) => {
        setUser(res.data);
        if (res.data.user_type === "client_user") {
          await loadCompaniesAndSetActive();
        }
      })
      .catch(() => {
        localStorage.removeItem("wqa_token");
      })
      .finally(() => {
        clearTimeout(timeout);
        setLoading(false);
      });
  }, []);

  const login = async (email, password) => {
    setError("");
    try {
      const res = await authAPI.login(email, password);
      localStorage.setItem("wqa_token", res.data.token);
      setUser(res.data.user);
      //ajay:code 11-08-26
      if (res.data.user.user_type === "client_user") {
        await loadCompaniesAndSetActive();
      }
      return true;
    } catch (err) {
      // Backend khare tar unreachable asel (network error, status नाहीच) tarach mock login वापरा.
      const isNetworkError = !err.status;
      const mock = MOCK_USERS[email];
      if (isNetworkError && mock && mock.password === password) {
        localStorage.setItem("wqa_token", "mock_token_" + email);
        setUser(mock.user);
        return true;
      }
      setError(err.data?.message || "Invalid email or password");
      return false;
    }
  };

  // const logout = () => {
  //   localStorage.removeItem("wqa_token");
  //   setUser(null);
  // };

  //ajay:code 11-08-26
  const logout = () => {
    localStorage.removeItem("wqa_token");
    localStorage.removeItem("wqa_active_company");
    setUser(null);
    setCompanies([]);
    setActiveCompany(null);
  };

  //ajay:code 11-08-26
  const loadCompaniesAndSetActive = async () => {
    try {
      const res = await clientAccessAPI.myCompanies();
      const list = res.data || [];
      setCompanies(list);

      if (list.length === 0) {
        setActiveCompany(null);
        return;
      }

      const savedId = localStorage.getItem("wqa_active_company");
      const saved = list.find((c) => String(c.company_id) === String(savedId));
      const chosen = saved || list[0]; // last-selected if still valid, else first

      localStorage.setItem("wqa_active_company", chosen.company_id);
      setActiveCompany(chosen);
    } catch (e) {
      setCompanies([]);
      setActiveCompany(null);
    }
  };
  // ajay:code 11-08-26
  const switchCompany = (companyId) => {
    const chosen = companies.find(
      (c) => String(c.company_id) === String(companyId),
    );
    if (!chosen) return;
    localStorage.setItem("wqa_active_company", chosen.company_id);
    setActiveCompany(chosen);
  };

  const hasPermission = (perm) => {
    if (!user) return false;
    if (
      user.user_type === "superadmin" ||
      user.user_type === "company" ||
      user.user_type === "company_user"
    )
      return true;
    return user.permissions?.includes(perm) ?? false;
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        logout,
        companies,
        activeCompany,
        switchCompany,
        error,
        loading,
        hasPermission,
      }}
    >
      {loading ? (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "var(--bg)",
          }}
        >
          <div style={{ color: "var(--text2)", fontSize: 13 }}>Loading...</div>
        </div>
      ) : (
        children
      )}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
